module.exports = __webpack_public_path__ + "img/telegram.16555e8e.svg";